import { Link } from 'react-router-dom';

function Home(props) {
  var sliders = [];
  props.sliders?.forEach((slider, index) => {
    sliders.push( index === 0 ? (
        <div className="carousel-item text-center active" data-bs-interval="5000">
          <Link to={slider?.attributes.link}><img src={process.env.REACT_APP_API_URL+slider?.attributes.image?.data?.attributes.url} className="d-block mx-auto rounded img-fluid" alt="..." /></Link>
        </div>
      ) : (
        <div className="carousel-item text-center" data-bs-interval="5000">
          <Link to={slider?.attributes.link}><img src={process.env.REACT_APP_API_URL+slider?.attributes.image?.data?.attributes.url} className="d-block mx-auto rounded img-fluid" alt="..." /></Link>
        </div>
      )
    );
  });

  setTimeout(() => {
    var carousel_button = document.getElementById("button-carousel");
    carousel_button.click();
  }, 5000);

  return (
    <div>
      <div id="carouselHome" className="carousel slide" data-bs-ride="true">
        <div className="carousel-inner p-5">
          {sliders}
        </div>
        <button className="carousel-control-prev" type="button" data-bs-target="#carouselHome" data-bs-slide="prev">
          <span className="carousel-control-prev-icon" aria-hidden="true"></span>
          <span className="visually-hidden">Previous</span>
        </button>
        <button id="button-carousel" className="carousel-control-next" type="button" data-bs-target="#carouselHome" data-bs-slide="next">
          <span className="carousel-control-next-icon" aria-hidden="true"></span>
          <span className="visually-hidden">Next</span>
        </button>
      </div>
      <div className="row mx-auto">
        <div className="col-8 offset-2 col-md-4 offset-md-4">
          <p className="fw-bold">Haz que tu negocio sea exitoso. Atendemos cafeterías, bares y restaurantes. ¡Tenemos todo lo que necesitas!</p>
        </div>
      </div>
      <div className="row mx-auto">
        <div className="col-12 col-md-6 p-3 d-flex flex-column">
          <div className="rounded bg-orange text-white p-2">
            Catálogo
          </div>
          <div className="rounded pt-2 border d-flex flex-column h-100" style={{minHeight: "400px"}}>
            <div className="bg-brown text-white" style={{height: "30%"}}>
              <Link to="catalogo/jarabes" className="text-decoration-none text-white">
                <div className="row h-100 mx-auto">
                  <div className="col-3 col-md-2 text-center d-flex align-items-center">
                    <img src="assets/img/catalogo-jarabes.png" className="img-fluid" alt="Jarabes" />
                  </div>
                  <div className="col-9 col-md-10 fw-semibold my-auto d-xl-none h4">
                    Jarabes
                  </div>
                  <div className="col-9 col-md-10 fw-semibold my-auto d-none d-xl-block h4">
                    Jarabes
                  </div>
                </div>
              </Link>
            </div>
            <div style={{height: "30%"}}>
              <Link to="catalogo/bases" className="text-decoration-none text-brown">
                <div className="row h-100 mx-auto">
                  <div className="col-3 col-md-2 text-center d-flex align-items-center">
                    <img src="assets/img/catalogo-bases.png" className="img-fluid" alt="Bases en polvo" />
                  </div>
                  <div className="col-9 col-md-10 fw-semibold my-auto d-xl-none h4">
                    Bases en polvo
                  </div>
                  <div className="col-9 col-md-10 fw-semibold my-auto d-none d-xl-block h4">
                    Bases en polvo
                  </div>
                </div>
              </Link>
            </div>
            <div className="bg-brown text-white" style={{height: "30%"}}>
              <Link to="catalogo/equipo-accesorios" className="text-decoration-none text-white">
                <div className="row h-100 mx-auto">
                  <div className="col-3 col-md-2 text-center d-flex align-items-center">
                    <img src="assets/img/catalogo-equipo.png" className="img-fluid" alt="Equipo y accesorios" />
                  </div>
                  <div className="col-9 col-md-10 fw-semibold my-auto d-xl-none h4">
                    Equipo y accesorios
                  </div>
                  <div className="col-9 col-md-10 fw-semibold my-auto d-none d-xl-block h4">
                    Equipo y accesorios
                  </div>
                </div>
              </Link>
            </div>
            <div style={{height: "10%"}}>
              <Link to="catalogo" className="text-decoration-none text-brown">
                <div className="row h-100">
                  <div className="col-12 col-md-12 fw-semibold my-auto text-start ps-5 d-xl-none">
                    Ver más
                  </div>
                  <div className="col-12 col-md-12 fw-semibold my-auto text-start ps-5 d-none d-xl-block">
                    Ver más
                  </div>
                </div>
              </Link>
            </div>
          </div>
        </div>
        <div className="col-12 col-md-6 p-3 d-flex flex-column">
          <div className="rounded bg-orange text-white p-2">
            Cursos
          </div>
          <div className="pt-2 d-flex flex-column h-100">
            <Link to="cursos"><img className="w-100 rounded" src="assets/img/cursos.jpg" alt="Cursos" /></Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Home;
